"use client";

import dynamic from "next/dynamic";

const ContactForm = dynamic(() => import("./ContactForm"), { ssr: false });

const Contact = () => {
  return <ContactForm />;
};

export default Contact;
